import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import { RouteConfig } from 'vue-router'
import { asyncRoutes, constantRoutes } from '@/router'
import store from '@/store'

const hasPermission = (permissions: string[], route: RouteConfig) => {
  if (route.meta && route.meta.permissions) {
    return permissions.some(permission => route?.meta?.permissions?.includes(permission))
  } else {
    return true
  }
}

const canShow = (route: RouteConfig, isMobile: boolean) => {
  if (route.meta && route.meta.onlyShowInPC) {
    return !isMobile
  }
  return true
}

export const filterAsyncRoutes = (routes: RouteConfig[], permissions: string[], isMobile: boolean) => {
  const res: RouteConfig[] = []
  routes.forEach(route => {
    const r = { ...route }
    if (hasPermission(permissions, r) && canShow(r, isMobile)) {
      if (r.children) {
        r.children = filterAsyncRoutes(r.children, permissions, isMobile)
      }
      res.push(r)
    }
  })
  return res
}

export interface IPermissionState {
  routes: RouteConfig[]
  dynamicRoutes: RouteConfig[]
}

@Module({ dynamic: true, store, name: 'permission' })
class Permission extends VuexModule implements IPermissionState {
  public routes: RouteConfig[] = []
  public dynamicRoutes: RouteConfig[] = []
  public isMobile = false

  @Mutation
  private SET_ROUTES(routes: RouteConfig[]) {
    this.routes = constantRoutes.concat(routes)
    this.dynamicRoutes = routes
  }

  @Mutation
  private SET_IS_MOBILE(isMobile: boolean) {
    this.isMobile = isMobile
  }

  @Action
  public GenerateRoutes(permissions: string[]) {
    if(permissions) {
      let accessedRoutes
      if (permissions.includes('上帝')) {
        accessedRoutes = asyncRoutes
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, permissions, this.isMobile)
      }
      this.context.commit("SET_ROUTES", accessedRoutes)
    }
  }

  @Action
  public SetIsMobile(isMobile: boolean) {
    this.context.commit('SET_IS_MOBILE', isMobile)
  }
}

export const PermissionModule = getModule(Permission)
